<div matDialogTitle>
    {{ title }}
</div>

<mat-dialog-content class="tw-text-center">
    {{ body }}
</mat-dialog-content>

<app-dialog-exit (closeClick)="onClickClose()"></app-dialog-exit>
